module.exports = __webpack_public_path__ + "static/media/memory_life.3147e524.jpeg";